/* global require */
/* global module */
'use strict';

var AnalyticsSchema = require('./analytics/AnalyticsSchema.json');
var ElasticSchema = require('./elastic/ElasticSchema.json');
var CustomerEngagementSchema = require('./customerEngagement/CustomerEngagementSchema.json');

module.exports = {
    AnalyticsSchema : AnalyticsSchema,
    ElasticSchema: ElasticSchema,
    CustomerEngagementSchema: CustomerEngagementSchema
};
